import React from 'react';
import BiddingProcessSection from './BiddingProcessSection/BiddingProcessSection';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import Consultants from 'commonComponents/Consultants/Consultants';
import { images1, images2, photos } from './images';

import styles from '../pages.module.scss';

const SalesMarketingStrategiesPage = ({
  banner, first, second, experts, salesFunnelLink
}) => {
  const firstProps = generateBiddingProcessProps(first, salesFunnelLink, photos[0], images1); 
  const secondProps = generateBiddingProcessProps(second, salesFunnelLink, photos[1], images2);

  const { name, position } = experts;
  const consultants = [
    { name: 'Andre Torkler' },
    { name: 'Endre Kirnig' || name, position, isPrimary: true },
    { name: 'Hofmann Anton' }
  ];
  
  return (
    <div className={ styles.Page }>
      <StageWithText { ...banner } pageName='PropertyTransactionProcess'
        type='wide'
      />
      <BiddingProcessSection { ...firstProps } anchor='bidding-process' />
      <BiddingProcessSection { ...secondProps } anchor='high-price-method' />
      <Consultants { ...experts }
        consultants={ consultants }
        link={ salesFunnelLink }
        type="short"
      />
    </div>
  );
};

const generateBiddingProcessProps = (data, link, overviewPhoto, images) => {
  const dataWithImages = { ...data };
  const content = [...data.content];

  dataWithImages.summary.photo = overviewPhoto;
  dataWithImages.button.link = link;

  for (const key in content) {
    content[key].image = images[key];
  }

  dataWithImages.content = content;

  return dataWithImages;
};
 
export default SalesMarketingStrategiesPage;
